export const defaultToolbarItems = {
  items: [
    'customUndo',
    'customRedo',
    '|',
    'customSourceEditing',
    '|',
    'heading',
    'customFontSize',
    '|',
    'customFontColor',
    'customBold',
    'customItalic',
    'customUnderline',
    'customStrikethrough',
    '|',
    'alignment',
    'customNumberedList',
    'customBulletedList',
    'customLink',
    'customTable',
    'mergeTableCells',
    'tableProperties'
  ],
  shouldNotGroupWhenFull: false,
}

export const defaultFontSizeOptions = {
  options: [ 8, 9, 10, 11, 12, 14, 16, 18, 22, 24, 26, 28, 30, 36, 48, 72 ],
  supportAllValues: true,
  defaultValue: 14,
}

export const defaultHeadingOptions = {
  options: [
    {
      model: 'heading1',
      view: {
        name: 'h1',
        styles: {
          'font-size': '22px'
        }
      },
      title: 'Título 1'
    },
    {
      model: 'heading2',
      view: {
        name: 'h2',
        styles: {
          'font-size': '18px'
        }
      },
      title: 'Título 2'
    },
    {
      model: 'paragraph',
      title: 'Texto'
    }
  ]
}

export const defaultHtmlSupport = {
  allow: [
    {
      name: [
        'p',
        'strong',
        'em',
        'u',
        's',
        'a',
        'ul',
        'ol',
        'li',
        'span',
        'div',
        'h1',
        'h2',
        'h3',
        'h4',
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td',
        'img',
      ],
      styles: {
        'font-size': true,
        'color': true,
        'text-align': true
      },
      attributes: {
        'src': true,
        'alt': true,
        'href': true,
        'target': true,
        'download': true,
        'style': true,
        'border': true
      },
      classes: false
    }
  ],
  disallow: [
    {
      name: /^(script|iframe|object|embed|form|input|button|style|link)$/
    }
  ]
}

export const defaultLinkConfig = {
  addTargetToExternalLinks: true,
  defaultProtocol: 'https://',
  decorators: {
    toggleDownloadable: {
      mode: 'manual',
      label: 'Downloadable',
      attributes: {
        download: 'file',
      },
    },
  },
}

export const defaultListConfig = {
  properties: {
    styles: true,
    startIndex: true,
    reversed: true,
  },
}

export const defaultFontColorConfig = {
  colorPicker: {
    format: 'hex'
  },

  colors: [
    { color: '#000000', label: 'Preto' },
    { color: '#808080', label: 'Cinza' },
    { color: '#FF0000', label: 'Vermelho' },
    { color: '#FFA500', label: 'Laranja' },
    { color: '#FFFF00', label: 'Amarelo' },
    { color: '#008000', label: 'Verde' },
    { color: '#0000FF', label: 'Azul' },
    { color: '#800080', label: 'Roxo' },
    { color: '#A52A2A', label: 'Marrom' },
    { color: '#FFC0CB', label: 'Rosa' },
  ]
}
